<template>
  <popup
    :show.sync="is_popup_show"
    width="500px"
    @on-close="is_popup_show = false"
  >
    <div
      style="padding: 25px 0"
      class="flex flex-direction justify-center align-center"
     
    >
      <img
        src="../../../assets/images/patternMaker/accept-image.png"
        style="width: 112px; height: 112px"
        alt=""
      />
      <h1>确认接单？</h1>
      <div
        class="text-666 margin-top-10 text-14 text-center"
        style="width: 335px; line-height: 22px"
      >
        接单后请尽快完成找货、寄样并在约定时间内发出大货，逾期将影响您在平台的评分
      </div>
      <div class="flex align-center justify-center" style="margin-top: 40px">
        <button class="cancel-btn cu-btn" @click="is_popup_show = false">
          取消
        </button>
        <button
          class="confirm-btn cu-btn margin-left-10"
          @click="confirm()"
        >
          确认接单
        </button>
      </div>
    </div>
    
  </popup>
</template>

<script>
import Popup from "@/components/Popup.vue";
import { OrderAccept} from "@/api/procurement.js";

export default {
  name: "Accept",
  data() {
    return {
      is_popup_show: false,
      order: {},
    };
  },
  components: {
    Popup,
  },
  props: {},
  mounted() {},
  methods: {
    showModal(order) {
      this.order = order;
      this.is_popup_show = true;
    },
    confirm() {
      OrderAccept({
        uuid: this.order.uuid,
      })
        .then(() => {
          this.is_popup_show = false;
          this.$emit("confirm");
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.cancel-btn{
    width: 130px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #E3E3E3;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}
.confirm-btn{
    width: 130px;
    height: 44px;
    background: #FF5967;
    border-radius: 4px 4px 4px 4px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
}
.order-info{
    padding-top: 24px;
    border-top: 1px dashed #B3B3B3;
}
</style>
